﻿import Toastify from "toastify-js";

export type NotificationType = "info" | "warning";

const showNotification = (content: string, type: NotificationType = "info") => {
  Toastify({
    text: content,
    gravity: "bottom",
    position: "center",
    stopOnFocus: true,
    close: true,
    duration: 4000,
    className: `notification ${type}`,
  }).showToast();
};

export const showInformationNotification = (content: string) => showNotification(content);

export const showWarningNotification = (content: string) => showNotification(content, "warning");
